
document.addEventListener("DOMContentLoaded", function () {
    var splide = new Splide("#main-slider", {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: true
    }).mount();

    function updateAllThumbnails(index) {
        // Combine both desktop and mobile thumbnails
        var thumbnails = document.querySelectorAll(".thumbnails img, .thumbnails1 img");
        thumbnails.forEach(function (thumb) {
            thumb.classList.remove("active");
            if (parseInt(thumb.getAttribute("data-index")) === index) {
                thumb.classList.add("active");
            }
        });
    }

    // Add click listeners for both sets
    var allThumbnails = document.querySelectorAll(".thumbnails img, .thumbnails1 img");
    allThumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener("click", function () {
            var index = parseInt(this.getAttribute("data-index"));
            splide.go(index);
        });
    });

    // Sync thumbnails on slide move
    splide.on("moved", function (newIndex) {
        updateAllThumbnails(newIndex);
    });
});
